var v = Object.defineProperty, f = Object.defineProperties;
var N = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var a = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var r = (o, s, c) => s in o ? v(o, s, { enumerable: !0, configurable: !0, writable: !0, value: c }) : o[s] = c, _ = (o, s) => {
  for (var c in s || (s = {}))
    a.call(s, c) && r(o, c, s[c]);
  if (n)
    for (var c of n(s))
      l.call(s, c) && r(o, c, s[c]);
  return o;
}, m = (o, s) => f(o, N(s));
var i = (o, s) => {
  var c = {};
  for (var h in o)
    a.call(o, h) && s.indexOf(h) < 0 && (c[h] = o[h]);
  if (o != null && n)
    for (var h of n(o))
      s.indexOf(h) < 0 && l.call(o, h) && (c[h] = o[h]);
  return c;
};
import x from "clsx";
import { createElement as C } from "react";
const H = "_h1_m42ov_1", M = "_h2_m42ov_2", w = "_h3_m42ov_3", y = "_color0_m42ov_24", z = "_color1_m42ov_28", e = {
  h1: H,
  h2: M,
  h3: w,
  color0: y,
  color1: z
}, T = ["h1", "h2", "h3"];
function A(b) {
  var t = b, {
    as: o,
    size: s = T.includes(o) ? o : "h1",
    color: c = "heading-0",
    className: h
  } = t, d = i(t, [
    "as",
    "size",
    "color",
    "className"
  ]);
  const p = {
    h1: e.h1,
    h2: e.h2,
    h3: e.h3
  }, g = {
    "heading-0": e.color0,
    "heading-1": e.color1
  }, u = x(
    p[s],
    g[c],
    h
  );
  return C(o, m(_({}, d), {
    className: u
  }));
}
export {
  A as default
};
